module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bm-wrap"
  }, [_c('modal', {
    staticClass: "bm-modal",
    attrs: {
      "name": "bannerModal",
      "adaptive": true,
      "scrollable": true,
      "height": "auto",
      "width": "90%",
      "maxWidth": 620
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "bm-dialog"
  }, [_c('div', {
    staticClass: "bm-dialog-header"
  }, [_c('div', {
    staticClass: "bm-dialog-header-left"
  }, [_c('span', {
    staticClass: "bm-dialog-icon"
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "3",
      "y": "3",
      "width": "18",
      "height": "18",
      "rx": "2"
    }
  }), _c('circle', {
    attrs: {
      "cx": "8.5",
      "cy": "8.5",
      "r": "1.5"
    }
  }), _c('polyline', {
    attrs: {
      "points": "21 15 16 10 5 21"
    }
  })])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "bm-dialog-title"
  }, [_vm._v(_vm._s(_vm.type) + " Banner")]), _vm._v(" "), _c('p', {
    staticClass: "bm-dialog-sub"
  }, [_vm._v("Upload an image and set a link for the in-app banner")])])]), _vm._v(" "), _c('button', {
    staticClass: "bm-close-btn",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('bannerModal')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "bm-dialog-body"
  }, [_c('div', {
    staticClass: "bm-field"
  }, [_c('label', {
    staticClass: "bm-label"
  }, [_vm._v("Banner Image")]), _vm._v(" "), _c('div', {
    staticClass: "bm-upload-row"
  }, [_c('label', {
    staticClass: "bm-file-zone",
    class: {
      'bm-file-zone--error': _vm.hasError
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "1.8",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }
  }), _c('polyline', {
    attrs: {
      "points": "17 8 12 3 7 8"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "3",
      "x2": "12",
      "y2": "15"
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.file && _vm.file.name ? _vm.file.name : 'Choose image (3:1 ratio, max 1 MB)'))]), _vm._v(" "), _c('input', {
    staticClass: "bm-file-hidden",
    attrs: {
      "type": "file",
      "id": "uploadInputFile",
      "name": "photo",
      "accept": "image/*"
    },
    on: {
      "change": _vm.changeFileHandle
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "bm-upload-btn",
    attrs: {
      "disabled": _vm.choosed
    },
    on: {
      "click": function($event) {
        return _vm.onupload()
      }
    }
  }, [(!_vm.uploadingBar) ? _c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
    }
  }), _c('polyline', {
    attrs: {
      "points": "17 8 12 3 7 8"
    }
  }), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "3",
      "x2": "12",
      "y2": "15"
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.uploadingBar ? _vm.uploadPercentage + '%' : 'Upload'))])])]), _vm._v(" "), (_vm.hasError) ? _c('p', {
    staticClass: "bm-error"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), (_vm.aspectRatioError) ? _c('p', {
    staticClass: "bm-error"
  }, [_vm._v(_vm._s(_vm.aspectRatioError))]) : _vm._e(), _vm._v(" "), (_vm.uploadingBar) ? _c('div', {
    staticClass: "bm-progress"
  }, [_c('div', {
    staticClass: "bm-progress-bar",
    style: ({
      width: _vm.uploadPercentage + '%'
    })
  })]) : _vm._e()]), _vm._v(" "), (_vm.url || _vm.bannerDetail.ImageUrl) ? _c('div', {
    staticClass: "bm-previews"
  }, [(_vm.url) ? _c('div', {
    staticClass: "bm-preview-item"
  }, [_c('span', {
    staticClass: "bm-preview-badge bm-preview-badge--new"
  }, [_vm._v("Preview")]), _vm._v(" "), _c('img', {
    staticClass: "bm-preview-img",
    attrs: {
      "src": _vm.url,
      "id": "image",
      "alt": "Preview"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.bannerDetail.ImageUrl) ? _c('div', {
    staticClass: "bm-preview-item"
  }, [_c('div', {
    staticClass: "bm-preview-actions"
  }, [_c('span', {
    staticClass: "bm-preview-badge bm-preview-badge--saved"
  }, [_vm._v("Saved")]), _vm._v(" "), _c('button', {
    staticClass: "bm-remove-btn",
    attrs: {
      "title": "Remove"
    },
    on: {
      "click": _vm.confirmRemoveBanner
    }
  }, [_c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "3 6 5 6 21 6"
    }
  }), _c('path', {
    attrs: {
      "d": "M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"
    }
  })]), _vm._v("\n                Remove\n              ")])]), _vm._v(" "), _c('img', {
    staticClass: "bm-preview-img",
    attrs: {
      "src": _vm.bannerDetail.ImageUrl,
      "alt": "Banner"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.bannerLink) ? _c('div', {
    staticClass: "bm-saved-link"
  }, [_c('span', {
    staticClass: "bm-preview-badge bm-preview-badge--saved"
  }, [_vm._v("Current Link")]), _vm._v(" "), _c('a', {
    staticClass: "bm-link",
    attrs: {
      "href": _vm.bannerLink,
      "target": "blank"
    }
  }, [_vm._v(_vm._s(_vm.bannerLink))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bm-field"
  }, [_c('label', {
    staticClass: "bm-label"
  }, [_vm._v("Banner Link (URL)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bannerDetail.Link),
      expression: "bannerDetail.Link"
    }],
    staticClass: "bm-input",
    attrs: {
      "type": "text",
      "name": "Link",
      "placeholder": "https://example.com"
    },
    domProps: {
      "value": (_vm.bannerDetail.Link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.bannerDetail, "Link", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.linkError) ? _c('p', {
    staticClass: "bm-error"
  }, [_vm._v(_vm._s(_vm.linkError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "bm-field"
  }, [_c('label', {
    staticClass: "bm-label"
  }, [_vm._v("Banner Type")]), _vm._v(" "), _c('div', {
    staticClass: "bm-select-wrap"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bannerDetail.Type),
      expression: "bannerDetail.Type"
    }],
    staticClass: "bm-select",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.bannerDetail, "Type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "REGULAR"
    }
  }, [_vm._v("Regular")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US BANNER"
    }
  }, [_vm._v("US Banner")])]), _vm._v(" "), _c('svg', {
    staticClass: "bm-select-icon",
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "6 9 12 15 18 9"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "bm-dialog-footer"
  }, [_c('button', {
    staticClass: "bm-cancel-btn",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('bannerModal')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "bm-save-btn",
    attrs: {
      "id": "save-banner"
    },
    on: {
      "click": function($event) {
        return _vm.saveBanner()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
    }
  }), _c('polyline', {
    attrs: {
      "points": "17 21 17 13 7 13 7 21"
    }
  }), _c('polyline', {
    attrs: {
      "points": "7 3 7 8 15 8"
    }
  })]), _vm._v("\n          Save Banner\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2111ea37"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/BannerManger/AddEditBanner.vue
// module id = 1681
// module chunks = 2